import { Box, Stack } from "@mui/material";

// Shared label/value row used in the Avustimen tulos card on the Betoni step,
// the result panel inside SpecGuideModal, and the Tarkista step's spec section.
// Renders "—" when value is empty so callers can pass raw draft fields without
// a guard.
//
// On phones the fixed 160px label column starved the value, breaking long codes
// (e.g. "XC3-4, XD1, XF1") character-by-character — so below sm the row stacks
// label-over-value and the value reclaims the full width; the side-by-side
// columns return at sm+.
export default function SpecRow({ label, value }) {
    return (
        <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={{ xs: 0.25, sm: 1.5 }}
            sx={{ alignItems: { xs: "flex-start", sm: "baseline" }, minWidth: 0 }}
        >
            <Box sx={{ fontSize: 13, color: "text.secondary", minWidth: { sm: 160 }, flexShrink: 0 }}>{label}</Box>
            <Box sx={{ fontSize: 14, fontWeight: 600, color: "text.primary", minWidth: 0, wordBreak: "break-word" }}>
                {value || "—"}
            </Box>
        </Stack>
    );
}
